var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVcard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 7.5h4.167V5.833H10zM10 5h4.167V3.333H10zm-7.5 5h6.667v-.458q0-.938-.917-1.49T5.833 7.5t-2.416.552-.917 1.49zm3.333-3.333q.688 0 1.177-.49T7.5 5t-.49-1.177a1.6 1.6 0 0 0-1.177-.49q-.687 0-1.177.49T4.166 5t.49 1.177 1.177.49m-4.166 6.666q-.688 0-1.177-.49A1.6 1.6 0 0 1 0 11.668v-10Q0 .979.49.49.979 0 1.667 0H15q.687 0 1.177.49.49.489.49 1.177v10q0 .687-.49 1.177t-1.177.49zm0-1.666H15v-10H1.667z"
})));
export default SvgVcard;